/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientContactArchivedReason = "doNotContact" | "none" | "unreachable" | "%future added value";
export type EnumPatientContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumPatientDemoConfigurationType = "default" | "lumabot" | "%future added value";
export type EnumUserDisplayStatus = "active" | "pending" | "suspended" | "%future added value";
export type EnumUserExternalIdSource = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "email" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "none" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "sms" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "voice" | "webedoctor" | "webpt" | "%future added value";
export type EnumUserGender = "female" | "male" | "nonbinary" | "unknown" | "%future added value";
export type EnumUserPasswordHashAlgorithm = "bcrypt" | "md5" | "sha256" | "sha512" | "%future added value";
export type EnumUserSalesforceDataAccountLifeline = "active" | "assigned" | "churned" | "converted" | "disqualified" | "nurture" | "openOpportunity" | "partnered" | "salesAccepted" | "salesQualified" | "trial" | "trialEndedNoConversion" | "unassigned" | "working" | "%future added value";
export type EnumUserSalesforceDataBoardSegment = "core" | "majors" | "reseller" | "strategic" | "sub20" | "unknown" | "%future added value";
export type EnumUserSalesforceDataHealthStatus = "advocate" | "churnRisk" | "green" | "healthy" | "neutral" | "poorFit" | "red" | "yellow" | "%future added value";
export type EnumUserSalesforceDataLifeline = "active" | "churn" | "converted" | "trial" | "%future added value";
export type EnumUserSalesforceDataOnboardingStage = "customerSuccessIntroduction" | "customization" | "discoveryCall" | "fullyImplemented" | "goLive" | "integration" | "kickoff" | "readyToLaunch" | "staffTraining" | "testing" | "%future added value";
export type EnumUserSecondaryExternalIdSource = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "email" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "none" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "sms" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "voice" | "webedoctor" | "webpt" | "%future added value";
export type EnumUserType = "doctor" | "guest" | "patient" | "staff" | "system" | "%future added value";
export type FilterFindManyUserInput = {
    name?: string | null | undefined;
    normalizedName?: string | null | undefined;
    firstname?: string | null | undefined;
    lastname?: string | null | undefined;
    middlename?: string | null | undefined;
    displayPhone?: string | null | undefined;
    displayStatus?: EnumUserDisplayStatus | null | undefined;
    email?: string | null | undefined;
    safeId?: string | null | undefined;
    type?: EnumUserType | null | undefined;
    roles?: Array<string | null> | null | undefined;
    rolesByUser?: PatientRolesByUserInput | null | undefined;
    organization?: string | null | undefined;
    contact?: Array<PatientContactInput | null> | null | undefined;
    doNotContact?: boolean | null | undefined;
    doNotContactMessage?: string | null | undefined;
    groups?: Array<string | null> | null | undefined;
    stripeCustomerId?: string | null | undefined;
    stripeSubscriptionId?: string | null | undefined;
    salesforceId?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    lastLogin?: unknown | null | undefined;
    active?: number | null | undefined;
    master?: boolean | null | undefined;
    language?: string | null | undefined;
    user?: string | null | undefined;
    setting?: string | null | undefined;
    settings?: unknown | null | undefined;
    address?: string | null | undefined;
    address2?: string | null | undefined;
    city?: string | null | undefined;
    state?: string | null | undefined;
    country?: string | null | undefined;
    postcode?: string | null | undefined;
    gender?: EnumUserGender | null | undefined;
    allowedIps?: Array<string | null> | null | undefined;
    avatar?: string | null | undefined;
    publicKey?: string | null | undefined;
    directMessagingEmail?: string | null | undefined;
    demoConfiguration?: PatientDemoConfigurationInput | null | undefined;
    website?: string | null | undefined;
    _id?: string | null | undefined;
    salesforceData?: UserSalesforceDataInput | null | undefined;
    externalId?: UserExternalIdInput | null | undefined;
    secondaryExternalId?: UserSecondaryExternalIdInput | null | undefined;
    dateOfBirth?: UserDateOfBirthInput | null | undefined;
    twoFactorAuthSecret?: UserTwoFactorAuthSecretInput | null | undefined;
    stats?: UserStatsInput | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyUserInput | null | undefined;
    OR?: Array<FilterFindManyUserInput> | null | undefined;
    AND?: Array<FilterFindManyUserInput> | null | undefined;
};
export type PatientRolesByUserInput = {
    referringProvider?: Array<string | null> | null | undefined;
    renderingProvider?: Array<string | null> | null | undefined;
    _id?: string | null | undefined;
};
export type PatientContactInput = {
    type?: EnumPatientContactType | null | undefined;
    value?: string | null | undefined;
    active?: boolean | null | undefined;
    archived?: boolean | null | undefined;
    archivedReason?: EnumPatientContactArchivedReason | null | undefined;
    archivedMessage?: string | null | undefined;
};
export type PatientDemoConfigurationInput = {
    type?: EnumPatientDemoConfigurationType | null | undefined;
    _id?: string | null | undefined;
};
export type UserSalesforceDataInput = {
    customerSuccessManager?: PatientSalesforceDataCustomerSuccessManagerInput | null | undefined;
    provisioning?: Array<string | null> | null | undefined;
    respectProvisioning?: boolean | null | undefined;
    lifeline?: EnumUserSalesforceDataLifeline | null | undefined;
    mrr?: number | null | undefined;
    renewalDate?: unknown | null | undefined;
    providers?: number | null | undefined;
    specialty?: string | null | undefined;
    referralTrialLimit?: number | null | undefined;
    recordType?: string | null | undefined;
    domesticAccessRequired?: boolean | null | undefined;
    goLiveAt?: unknown | null | undefined;
    fullyImplementedAt?: unknown | null | undefined;
    contractSignedAt?: unknown | null | undefined;
    contractLength?: number | null | undefined;
    ein?: string | null | undefined;
    healthStatus?: EnumUserSalesforceDataHealthStatus | null | undefined;
    boardSegment?: EnumUserSalesforceDataBoardSegment | null | undefined;
    onboardingStage?: EnumUserSalesforceDataOnboardingStage | null | undefined;
    accountLifeline?: EnumUserSalesforceDataAccountLifeline | null | undefined;
};
export type PatientSalesforceDataCustomerSuccessManagerInput = {
    name?: string | null | undefined;
    email?: string | null | undefined;
    phone?: string | null | undefined;
};
export type UserExternalIdInput = {
    source?: EnumUserExternalIdSource | null | undefined;
    value?: string | null | undefined;
};
export type UserSecondaryExternalIdInput = {
    source?: EnumUserSecondaryExternalIdSource | null | undefined;
    value?: string | null | undefined;
};
export type UserDateOfBirthInput = {
    year?: number | null | undefined;
    month?: number | null | undefined;
    day?: number | null | undefined;
};
export type UserTwoFactorAuthSecretInput = {
    enabled?: boolean | null | undefined;
};
export type UserStatsInput = {
    oldestAppointment?: unknown | null | undefined;
};
export type OperatorsFilterFindManyUserInput = {
    name?: NameOperatorsFilterFindManyUserInput | null | undefined;
    normalizedName?: NormalizedNameOperatorsFilterFindManyUserInput | null | undefined;
    firstname?: FirstnameOperatorsFilterFindManyUserInput | null | undefined;
    lastname?: LastnameOperatorsFilterFindManyUserInput | null | undefined;
    middlename?: MiddlenameOperatorsFilterFindManyUserInput | null | undefined;
    displayPhone?: DisplayPhoneOperatorsFilterFindManyUserInput | null | undefined;
    displayStatus?: DisplayStatusOperatorsFilterFindManyUserInput | null | undefined;
    email?: EmailOperatorsFilterFindManyUserInput | null | undefined;
    password?: PasswordOperatorsFilterFindManyUserInput | null | undefined;
    passwordHashAlgorithm?: PasswordHashAlgorithmOperatorsFilterFindManyUserInput | null | undefined;
    passwordUpdatedAt?: PasswordUpdatedAtOperatorsFilterFindManyUserInput | null | undefined;
    safeId?: SafeIdOperatorsFilterFindManyUserInput | null | undefined;
    resetPasswordToken?: ResetPasswordTokenOperatorsFilterFindManyUserInput | null | undefined;
    resetPasswordExpires?: ResetPasswordExpiresOperatorsFilterFindManyUserInput | null | undefined;
    type?: TypeOperatorsFilterFindManyUserInput | null | undefined;
    roles?: RolesOperatorsFilterFindManyUserInput | null | undefined;
    rolesByUser?: RolesByUserOperatorsFilterFindManyUserInput | null | undefined;
    organization?: OrganizationOperatorsFilterFindManyUserInput | null | undefined;
    contact?: ContactOperatorsFilterFindManyUserInput | null | undefined;
    doNotContact?: DoNotContactOperatorsFilterFindManyUserInput | null | undefined;
    doNotContactMessage?: DoNotContactMessageOperatorsFilterFindManyUserInput | null | undefined;
    groups?: GroupsOperatorsFilterFindManyUserInput | null | undefined;
    stripeCustomerId?: StripeCustomerIdOperatorsFilterFindManyUserInput | null | undefined;
    stripeSubscriptionId?: StripeSubscriptionIdOperatorsFilterFindManyUserInput | null | undefined;
    salesforceId?: SalesforceIdOperatorsFilterFindManyUserInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyUserInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyUserInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyUserInput | null | undefined;
    lastLogin?: LastLoginOperatorsFilterFindManyUserInput | null | undefined;
    token?: TokenOperatorsFilterFindManyUserInput | null | undefined;
    active?: ActiveOperatorsFilterFindManyUserInput | null | undefined;
    master?: MasterOperatorsFilterFindManyUserInput | null | undefined;
    language?: LanguageOperatorsFilterFindManyUserInput | null | undefined;
    user?: UserOperatorsFilterFindManyUserInput | null | undefined;
    setting?: SettingOperatorsFilterFindManyUserInput | null | undefined;
    settings?: SettingsOperatorsFilterFindManyUserInput | null | undefined;
    address?: AddressOperatorsFilterFindManyUserInput | null | undefined;
    address2?: Address2OperatorsFilterFindManyUserInput | null | undefined;
    city?: CityOperatorsFilterFindManyUserInput | null | undefined;
    state?: StateOperatorsFilterFindManyUserInput | null | undefined;
    country?: CountryOperatorsFilterFindManyUserInput | null | undefined;
    postcode?: PostcodeOperatorsFilterFindManyUserInput | null | undefined;
    gender?: GenderOperatorsFilterFindManyUserInput | null | undefined;
    allowedIps?: AllowedIpsOperatorsFilterFindManyUserInput | null | undefined;
    avatar?: AvatarOperatorsFilterFindManyUserInput | null | undefined;
    publicKey?: PublicKeyOperatorsFilterFindManyUserInput | null | undefined;
    directMessagingEmail?: DirectMessagingEmailOperatorsFilterFindManyUserInput | null | undefined;
    demoConfiguration?: DemoConfigurationOperatorsFilterFindManyUserInput | null | undefined;
    website?: WebsiteOperatorsFilterFindManyUserInput | null | undefined;
    _id?: _idOperatorsFilterFindManyUserInput | null | undefined;
};
export type NameOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type NormalizedNameOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FirstnameOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LastnameOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type MiddlenameOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DisplayPhoneOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DisplayStatusOperatorsFilterFindManyUserInput = {
    gt?: EnumUserDisplayStatus | null | undefined;
    gte?: EnumUserDisplayStatus | null | undefined;
    lt?: EnumUserDisplayStatus | null | undefined;
    lte?: EnumUserDisplayStatus | null | undefined;
    ne?: EnumUserDisplayStatus | null | undefined;
    in?: Array<EnumUserDisplayStatus | null> | null | undefined;
    nin?: Array<EnumUserDisplayStatus | null> | null | undefined;
    regex?: EnumUserDisplayStatus | null | undefined;
};
export type EmailOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PasswordOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PasswordHashAlgorithmOperatorsFilterFindManyUserInput = {
    gt?: EnumUserPasswordHashAlgorithm | null | undefined;
    gte?: EnumUserPasswordHashAlgorithm | null | undefined;
    lt?: EnumUserPasswordHashAlgorithm | null | undefined;
    lte?: EnumUserPasswordHashAlgorithm | null | undefined;
    ne?: EnumUserPasswordHashAlgorithm | null | undefined;
    in?: Array<EnumUserPasswordHashAlgorithm | null> | null | undefined;
    nin?: Array<EnumUserPasswordHashAlgorithm | null> | null | undefined;
    regex?: EnumUserPasswordHashAlgorithm | null | undefined;
};
export type PasswordUpdatedAtOperatorsFilterFindManyUserInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type SafeIdOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ResetPasswordTokenOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ResetPasswordExpiresOperatorsFilterFindManyUserInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type TypeOperatorsFilterFindManyUserInput = {
    gt?: EnumUserType | null | undefined;
    gte?: EnumUserType | null | undefined;
    lt?: EnumUserType | null | undefined;
    lte?: EnumUserType | null | undefined;
    ne?: EnumUserType | null | undefined;
    in?: Array<EnumUserType | null> | null | undefined;
    nin?: Array<EnumUserType | null> | null | undefined;
    regex?: EnumUserType | null | undefined;
};
export type RolesOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RolesByUserOperatorsFilterFindManyUserInput = {
    gt?: PatientRolesByUserInput | null | undefined;
    gte?: PatientRolesByUserInput | null | undefined;
    lt?: PatientRolesByUserInput | null | undefined;
    lte?: PatientRolesByUserInput | null | undefined;
    ne?: PatientRolesByUserInput | null | undefined;
    in?: Array<PatientRolesByUserInput | null> | null | undefined;
    nin?: Array<PatientRolesByUserInput | null> | null | undefined;
    regex?: PatientRolesByUserInput | null | undefined;
};
export type OrganizationOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ContactOperatorsFilterFindManyUserInput = {
    gt?: PatientContactInput | null | undefined;
    gte?: PatientContactInput | null | undefined;
    lt?: PatientContactInput | null | undefined;
    lte?: PatientContactInput | null | undefined;
    ne?: PatientContactInput | null | undefined;
    in?: Array<PatientContactInput | null> | null | undefined;
    nin?: Array<PatientContactInput | null> | null | undefined;
    regex?: PatientContactInput | null | undefined;
};
export type DoNotContactOperatorsFilterFindManyUserInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type DoNotContactMessageOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GroupsOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StripeCustomerIdOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StripeSubscriptionIdOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SalesforceIdOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyUserInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyUserInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyUserInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type LastLoginOperatorsFilterFindManyUserInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type TokenOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ActiveOperatorsFilterFindManyUserInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type MasterOperatorsFilterFindManyUserInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type LanguageOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UserOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SettingOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SettingsOperatorsFilterFindManyUserInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type AddressOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type Address2OperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CityOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StateOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CountryOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PostcodeOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type GenderOperatorsFilterFindManyUserInput = {
    gt?: EnumUserGender | null | undefined;
    gte?: EnumUserGender | null | undefined;
    lt?: EnumUserGender | null | undefined;
    lte?: EnumUserGender | null | undefined;
    ne?: EnumUserGender | null | undefined;
    in?: Array<EnumUserGender | null> | null | undefined;
    nin?: Array<EnumUserGender | null> | null | undefined;
    regex?: EnumUserGender | null | undefined;
};
export type AllowedIpsOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AvatarOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PublicKeyOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DirectMessagingEmailOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DemoConfigurationOperatorsFilterFindManyUserInput = {
    gt?: PatientDemoConfigurationInput | null | undefined;
    gte?: PatientDemoConfigurationInput | null | undefined;
    lt?: PatientDemoConfigurationInput | null | undefined;
    lte?: PatientDemoConfigurationInput | null | undefined;
    ne?: PatientDemoConfigurationInput | null | undefined;
    in?: Array<PatientDemoConfigurationInput | null> | null | undefined;
    nin?: Array<PatientDemoConfigurationInput | null> | null | undefined;
    regex?: PatientDemoConfigurationInput | null | undefined;
};
export type WebsiteOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyUserInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FiltersApproverDataQueryVariables = {
    filter?: FilterFindManyUserInput | null | undefined;
};
export type FiltersApproverDataQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FiltersApproverList_Query">;
};
export type FiltersApproverDataQuery = {
    readonly response: FiltersApproverDataQueryResponse;
    readonly variables: FiltersApproverDataQueryVariables;
};



/*
query FiltersApproverDataQuery(
  $filter: FilterFindManyUserInput
) {
  ...FiltersApproverList_Query
}

fragment FiltersApproverList_Query on Query {
  userConnection(first: 25, filter: $filter, sort: NAME_ASC, includeDeleted: true) {
    edges {
      node {
        _id
        firstname
        lastname
        deleted
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Literal",
    "name": "includeDeleted",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "NAME_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FiltersApproverDataQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FiltersApproverList_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FiltersApproverDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "userConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort",
          "includeDeleted"
        ],
        "handle": "connection",
        "key": "FiltersApproverList_userConnection",
        "kind": "LinkedHandle",
        "name": "userConnection"
      }
    ]
  },
  "params": {
    "cacheID": "32b62fb1352413fdbcdfcf7a74e5a66d",
    "id": null,
    "metadata": {},
    "name": "FiltersApproverDataQuery",
    "operationKind": "query",
    "text": "query FiltersApproverDataQuery(\n  $filter: FilterFindManyUserInput\n) {\n  ...FiltersApproverList_Query\n}\n\nfragment FiltersApproverList_Query on Query {\n  userConnection(first: 25, filter: $filter, sort: NAME_ASC, includeDeleted: true) {\n    edges {\n      node {\n        _id\n        firstname\n        lastname\n        deleted\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '5af215c5398cddf413f77eaca4fe8e9c';
export default node;
